module.exports = __webpack_public_path__ + "img/charger-speeds-desktop@2x.1106fd35.webp";